import { baseUrl } from "../../app/constants";

export function fetchProductById(id) {
  return new Promise(async (resolve) => {
    const response = await fetch(baseUrl+'/products/' + id);
    const data = await response.json();
    resolve({ data });
  });
}

export function createProduct(product) {
  return new Promise(async (resolve) => {
    const response = await fetch(baseUrl+'/products/', {
      method: 'POST',
      body: JSON.stringify(product),
      headers: { 'content-type': 'application/json' },
    });
    const data = await response.json();
    resolve({ data });
  });
}

export function updateProduct(update) {
  return new Promise(async (resolve) => {
    const response = await fetch(
      baseUrl+ '/products/' + update.id,
      {
        method: 'PATCH',
        body: JSON.stringify(update),
        headers: { 'content-type': 'application/json' },
      }
    );
    const data = await response.json();
    resolve({ data });
  });
}

export function fetchProductsByFilters(page) {


  return new Promise(async (resolve) => {
    const response = await fetch(
      baseUrl+ `/products?pages=${page}`
    );
    const data = await response.json();
    const totalItems = await response.headers.get('X-Total-Count');
    resolve({ data: { products: data, totalItems: +totalItems } });
  });
}

export function fetchCategories() {
  return new Promise(async (resolve) => {
    const response = await fetch(baseUrl+'/categories');
    const data = await response.json();
    resolve({ data });
  });
}

export function fetchBrands() {
  return new Promise(async (resolve) => {
    const response = await fetch(baseUrl+'/brands');
    const data = await response.json();
    resolve({ data });
  });
}

export function fetchProductsByGenre({ page, genre }) {
  return new Promise(async (resolve) => {
    const response = await fetch(
      `${baseUrl}/products?genre=${encodeURIComponent(genre)}&pages=${page}`
    );

    const data = await response.json();
    const totalItems = await response.headers.get('X-Total-Count');

    resolve({ data: { products: data, totalItems: +totalItems } });
  });
}




